import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field, submit, Form, formValueSelector } from 'redux-form/immutable';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';

import {
  TextField,
} from 'redux-form-material-ui';

import ReduxDialog from '../Common/ReduxDialog';

import commonStyles from '../styles';
import styles from './styles';

import { showDialog, hideDialog } from '../../actions/dialogs';
import { savePrinterFormHandler } from '../../routines';
import { renderSelectField } from '../../utils/reduxforms';
import { required, ip } from '../../utils/formvalidation';

class Printer extends Component {
  static propTypes = {
    initialValues: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submit: PropTypes.func.isRequired,

    showDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
  };

  state = {};

  componentWillMount() {
  }

  handleDiscard = () => {
    this.props.hideDialog('printer');
  };

  handleSave = () => {
    console.log('handleSave');
  };

  render() {
    const { handleSubmit, initialValues, connection } = this.props;

    const actions = [
      <FlatButton
        label="Cancel"
        primary
        onClick={this.handleDiscard}
      />,
      <FlatButton
        label="Save"
        primary
        onClick={() => this.props.submit('TaskProfile')}
      />,
    ];

    return (
      <ReduxDialog
        title={initialValues.get('name') || 'Add Printer'}
        subTitle={'Add a label printer for high speed label printing'}
        actions={actions}
        name="printer"
        onRequestClose={this.handleDiscard}
        bodyStyle={styles.body}
      >
        <Form name="Printer" onSubmit={handleSubmit(savePrinterFormHandler)}>
          <div style={commonStyles.row}>
            <Field
              name="name"
              style={commonStyles.input}
              component={TextField}
              floatingLabelText="Name"
              floatingLabelFixed
              fullWidth
              validate={[required]}/>
          </div>
          <div style={commonStyles.row}>
            <Field
              name="type"
              component={renderSelectField}
              style={commonStyles.input}
              floatingLabelText="Type"
              floatingLabelFixed
              fullWidth
              validate={[required]}
            >
              <MenuItem key="zebra" value="zebra" primaryText="Zebra"/>
            </Field>
            <Field
              name="connection"
              component={renderSelectField}
              style={commonStyles.input}
              floatingLabelText="Connection"
              floatingLabelFixed
              fullWidth
              validate={[required]}
            >
              <MenuItem key="network" value="network" primaryText="Network" />
              <MenuItem key="usb" value="usb" primaryText="USB" />
            </Field>
            <Field
              name="ip"
              style={commonStyles.input}
              component={TextField}
              floatingLabelText="IP"
              floatingLabelFixed
              fullWidth
              disabled={connection !== 'network'}
              validate={connection === 'network' ? [required, ip] : []} />
          </div>
        </Form>

      </ReduxDialog>
    );
  }
}

const form = reduxForm({
  form: 'Printer',  // a unique identifier for this form
  onSubmitSuccess: (result, dispatch, props) => {
    console.log('onSubmitSuccess');
    props.hideDialog('printer');
  },
  onSubmitFail: (err) => {
    console.log('onSubmitFail', err);
  },
})(Printer);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    submit,
    showDialog,
    hideDialog,
  }, dispatch);
}

function mapStateToProps(state) {
  const selector = formValueSelector('Printer');

  console.log('printer', state.getIn(['dialogs', 'dialogs', 'printer', 'context', 'printer']).toJS());

  return {
    initialValues: state.getIn(['dialogs', 'dialogs', 'printer', 'context', 'printer']).toJS(),
    dialogs: state.get('dialogs').get('dialogs').toJS(),
    connection: selector(state, 'connection'),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Printer/index.js